import { selectApp } from './selectApp';

export const selectApiApplicationId = state => selectApp(state).api_application_id || null;
